import React from 'react';
import classNames from 'classnames';
import './Navigation.scss';

const Navigation = ({ children }) => {
  return <div className={classNames('c-nav')}>{children}</div>;
};

export default Navigation;
